// extracted by mini-css-extract-plugin
export default {"SupportModalContainer":"styles_SupportModalContainer__cSbtJ","title":"styles_title__15+0n"};